import { Aggregations } from 'js/model/rainbow/browse-page/Aggregations';
import { NamedEntityCountOutput } from 'js/model/rainbow/NamedEntityCountOutput';
import {
  createBrowseLocationUri,
  createBrowseTreatmentUri,
  createBrowseTreatmentTypeUri,
} from 'js/helpers/browse-uris';
import { Dictionary } from 'js/types/generic-types';

export interface AggregationEntity extends NamedEntityCountOutput {
  uri?: string;
}

interface Channel {
  code: string;
  languageCode: string;
}

export function createBrowseAggregations(
  aggregations: Aggregations,
  channel: Channel,
  pageParameters?: Dictionary<[string]>
): Aggregations {
  return {
    locations: aggregations.locations.map(
      addUriFunction(channel, createBrowseLocationUri, pageParameters)
    ),

    treatmentCategories: aggregations.treatmentCategories.map(
      addUriFunction(channel, createBrowseTreatmentUri, pageParameters)
    ),

    treatmentCategoryGroups: aggregations.treatmentCategoryGroups.map(
      addUriFunction(channel, createBrowseTreatmentTypeUri, pageParameters)
    ),

    // Currently there is no venueType property in the aggregations API response.
    // However, in order for the venue type to appear in the dropdown list and in the
    // type ahead of the treatment search tab, it needs to be in the aggregations.
    // This is a workaround for now, as venueType might be added to aggregations
    // in the future.

    venueTypes: aggregations.treatmentCategories.map(
      addUriFunction(channel, createBrowseLocationUri, pageParameters)
    ),
  };
}

function addUriFunction(
  channel: Channel,
  addUri: (
    normalisedName: string,
    channel: { code: string; languageCode: string },
    initialPageParameters?: { [key: string]: unknown }
  ) => string,
  pageParameters?: { [key: string]: unknown }
): (entity: NamedEntityCountOutput) => AggregationEntity {
  return function (entity: NamedEntityCountOutput): AggregationEntity {
    return {
      ...entity,
      uri: addUri(entity.normalisedName, channel, pageParameters),
    };
  };
}
